import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { dashboardApi } from "../../api/dashboard";
import { checkoutApi } from "../../api/checkout";
import LicenceCard from "./LicenceCard";
import TrialPanel from "../TrialPanel";
import { trackBeginCheckout } from "../../lib/analytics";

export default function LicencesPage() {
  const [licences, setLicences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { t } = useTranslation("dashboard");

  const fetchLicences = async () => {
    try { const resp = await dashboardApi.getLicences(); setLicences(resp.data); }
    catch { setError(t("licences.loadError")); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchLicences(); }, []);

  const handleDeactivate = async (licenceKey, fingerprint) => {
    await dashboardApi.deactivateMachine(licenceKey, fingerprint);
    fetchLicences();
  };

  const handleBuy = async () => {
    try {
      // Dashboard buyers already have an account, so they reach Stripe directly.
      // This is how a trial converts, and it was the one checkout entry point
      // firing no begin_checkout at all, which made those sales invisible.
      trackBeginCheckout({ step: "stripe_session", page: "dashboard" });
      const resp = await checkoutApi.createSession();
      window.location.href = resp.data.url;
    } catch { setError(t("licences.checkoutError")); }
  };

  if (loading) return <p className="text-[#A1A1AA]">{t("licences.loading")}</p>;

  const hasLicence = licences.length > 0;

  return (
    <div>
      <img src="/trapman-wordmark.png" alt="TrapMan" className="h-12 w-auto invert mb-6" />
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="font-clash text-2xl font-bold text-white">{t("licences.heading")}</h1>
        <button onClick={handleBuy} className="btn-primary px-6 py-2 rounded text-sm font-semibold">{t("licences.buy")}</button>
      </div>
      <TrialPanel />
      {error && <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded mb-4 text-sm">{error}</div>}
      {!hasLicence ? (
        <div className="feature-card rounded-lg p-12 text-center">
          <p className="text-[#A1A1AA] mb-4">{t("licences.empty")}</p>
          <button onClick={handleBuy} className="btn-primary px-8 py-3 rounded text-sm font-semibold">{t("licences.buyPriced")}</button>
        </div>
      ) : (
        <div className="space-y-4">
          {licences.map((item) => (
            <LicenceCard key={item.licence.licence_key} licence={item.licence} machines={item.machines || []} order={item.order} onDeactivate={handleDeactivate} />
          ))}
        </div>
      )}
    </div>
  );
}
